type EmbeddableContentType = 'procedure' | 'proceduregroup' | 'policy';

export const documentEmbedCode = (
  {
    id,
    embed_url,
  }: {
    id: number;
    embed_url: string;
  },
  contentType: EmbeddableContentType,
  staticURL: string
): string =>
  `<sp:${contentType} id="sp-${contentType}-${id}" href="${embed_url}" ></sp:${contentType}> <script>(function(d, s, id) {var js,pjs=d.getElementsByTagName(s)[0];if(d.getElementById(id)){return;}js=d.createElement(s);js.id=id;js.src="${staticURL}js/sp-embed.js";pjs.parentNode.insertBefore(js, pjs);}(document,"script","sweetprocess-jssdk"));</script>`;

export const legacyDocumentEmbedCode = (
  {
    id,
    embed_url,
  }: {
    id: number;
    embed_url: string;
  },
  contentType: EmbeddableContentType
): string =>
  `<iframe width="600" height="600" id="sp-${contentType}-${id}" src="${embed_url}"></iframe>`;
